import { useState } from "react";
import { SectionHeader } from "./Section";
import { CategoryTabs } from "./gallery/CategoryTabs";
import { CategoryHero } from "./gallery/CategoryHero";
import { GALLERY_CATEGORIES } from "./gallery/categories";

export function Gallery() {
    const [activeId, setActiveId] = useState(GALLERY_CATEGORIES[0].id);
    const active =
        GALLERY_CATEGORIES.find((c) => c.id === activeId) ?? GALLERY_CATEGORIES[0];

    return (
        <section id="projects" className="relative bg-navy-deep py-20 sm:py-28">
            <div className="container-x">
                <SectionHeader
                    eyebrow="Projects Gallery"
                    title={
                        <>
                            Selected work across <span className="text-orange">professional experience</span>
                        </>
                    }
                    intro="Explore selected projects and field
                     campaigns delivered by our team members throughout their professional experience across the energy and industrial sectors."
                    align="center"
                    invert
                />

                <div className="mt-10">
                    <CategoryTabs
                        categories={GALLERY_CATEGORIES}
                        activeId={activeId}
                        onSelect={setActiveId}
                    />
                </div>

                <div className="mt-10">
                    <CategoryHero category={active} />
                </div>
            </div>
        </section>
    );
}
